import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Nullable } from '../../types';

export enum StateKey {
  solde = 'solde',
  renouvellement = 'renouvellement',
}

// Ce service permet de récupérer/envoyer les données depuis/vers l'App Angular Legacy.
@Injectable({
  providedIn: 'root',
})
export class SharedStateLegacyService {
  private stateSubjects: { [key: string]: BehaviorSubject<Nullable<string>> } =
    {};

  constructor() {
    Object.values(StateKey).forEach((key) => {
      this.stateSubjects[key] = new BehaviorSubject<Nullable<string>>(
        this.getItem(key),
      );
    });
  }

  public clear(): void {
    sessionStorage.clear();
    Object.keys(this.stateSubjects).forEach((key) => {
      this.stateSubjects[key].next(null);
    });
  }

  public getItem(key: StateKey): Nullable<string> {
    if (typeof window === 'undefined') return null;
    return sessionStorage.getItem(key);
  }

  public setItem(key: StateKey, value: string) {
    if (typeof window !== 'undefined') {
      sessionStorage.setItem(key, value);
      this.stateSubjects[key].next(value);
    }
  }

  public getStateObservable(key: StateKey): Observable<Nullable<string>> {
    return this.stateSubjects[key].asObservable();
  }
}
